import * as tslib_1 from "tslib";
import { ChangeDetectorRef, OnInit, AfterViewInit, ElementRef, OnDestroy } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap';
import { Subject } from 'rxjs';
import { SystemSettingsService } from '@app/services';
import { JobViewService } from '@app/features/customers/customer/jobs-view/service/job-view-service';
import { debounceTime, takeUntil } from 'rxjs/operators';
var FulfilPartsModal = /** @class */ (function () {
    function FulfilPartsModal(formBuilder, ajsScope, jobViewService, bsModalRef, changeDetector, systemSettingsService, jobData, ajsState) {
        this.formBuilder = formBuilder;
        this.ajsScope = ajsScope;
        this.jobViewService = jobViewService;
        this.bsModalRef = bsModalRef;
        this.changeDetector = changeDetector;
        this.systemSettingsService = systemSettingsService;
        this.jobData = jobData;
        this.ajsState = ajsState;
        this.title = 'Add part kit';
        this.closeBtnName = 'Cancel';
        this.select2Config = {};
        this.stockLocationsSelect2Config = {};
        this.selectedRows = {};
        this.jobId = '';
        this.customerId = '';
        this.customerType = '';
        this.selectedEngineerStockLocations = [];
        this.selectedPartsId = '';
        this.moduleId = '';
        this.jobToDos = '';
        this.action = '';
        this.isDataReady = false;
        this.engineerStocklocations = [];
        this.massStockSource = '';
        this.massUpdateDropdownOpen = false;
        this.fulfilFromStockRooms = [];
        this.fulfilFromOthers = [
            { id: 1, label: 'Order remaining from supplier', selected: false },
            { id: 2, label: 'Leave remaining on request', selected: false },
            { id: 3, label: 'Mark as available', selected: false }
        ];
        this.fulfilFromOtherMapping = {
            1: 'job.purchase.order',
            2: 'job.leave.remaining',
            3: 'job.general'
        };
        this.parts = [];
        this.String = String;
        this._isProcessing = false;
        this.formUpdateDebouncer = new Subject();
        this.destroyed$ = new Subject();
        this.select2DataFunction = function (item) { return item.text; };
        this.completionSummary = {
            stockLocationTotals: [],
            otherSourceTotals: {},
            fulfilledPartsCount: 0,
            notFulfilledPartsCount: 0,
            totalPartsCount: 0
        };
        this.isOrderFromSupplier = false;
        this.searchLocation = '';
        this.filteredStockRooms = [];
        this.isStockModule = false;
    }
    Object.defineProperty(FulfilPartsModal.prototype, "f", {
        get: function () {
            return this.form.controls;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FulfilPartsModal.prototype, "select2StockLocs", {
        set: function (el) {
            var _this = this;
            if (el) {
                this._select2StockLocs = el;
                // Ensure Select2 is initialized if it's not already
                if (!$(this._select2StockLocs.nativeElement).data('select2')) {
                    this.initAndAttachMainSelect2();
                }
                $(this._select2StockLocs.nativeElement).on('change', function () {
                    _this.updateLocation();
                    _this.updateLocationViewStatus();
                });
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FulfilPartsModal.prototype, "partsFormArray", {
        get: function () {
            return this.form.get('parts')['controls'];
        },
        enumerable: true,
        configurable: true
    });
    FulfilPartsModal.prototype.ngOnInit = function () {
        var _this = this;
        this.onClose = new Subject();
        this.form = this.formBuilder.group({
            checkEngineerStockLocations: [this.selectedEngineerStockLocations, Validators.required],
            parts: this.formBuilder.array([])
        });
        this.getPartsAvailableStockLocations();
        this.initStockLocationSelect2();
        // Debounced form changes subscription
        this.formUpdateDebouncer
            .pipe(debounceTime(300), takeUntil(this.destroyed$))
            .subscribe(function () {
            _this.updateAllPartStatuses();
        });
        // Subscribe to form changes
        this.form.valueChanges
            .pipe(takeUntil(this.destroyed$))
            .subscribe(function () {
            _this.formUpdateDebouncer.next();
        });
        this.filteredStockRooms = this.fulfilFromStockRooms.slice();
    };
    FulfilPartsModal.prototype.fulfil = function () {
        var _this = this;
        if (this.completionSummary.totalPartsCount == this.completionSummary.fulfilledPartsCount) {
            this.action = 'fulfilling';
            if (this.isOrderFromSupplier && this.moduleId != '1') {
                this.parts.forEach(function (p) { return delete p.name; }); // name not required , cause json parse error
                this.jobData.setPartLocations(this.partsStockLocations);
                this.jobData.setSelectedPart(this.parts);
                this.ajsState.transitionTo('loggedin.customer_list.view.job.details.new_job_part_purchase_order', { id: this.customerId, jobId: this.jobId, type: this.customerType });
                this.bsModalRef.hide();
            }
            else {
                var data = {};
                data.selectedParts = JSON.stringify(this.parts);
                data.clientJobType = this.moduleId;
                data.jobToDos = this.jobToDos;
                data.jobId = this.jobId;
                data.milestoneId = 0;
                data.mergeJobPartIds = JSON.stringify([]);
                this.jobViewService.saveFulfilSelectedParts(data).subscribe(function (response) {
                    _this.action = '';
                    _this.onClose.next(true);
                }, function (error) {
                    _this.action = '';
                    console.log('err', error);
                });
            }
        }
    };
    FulfilPartsModal.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.activeTab = 'requires';
        this.changeDetector.detectChanges();
        // Initialize select2 for each part's fulfil from other dropdown
        setTimeout(function () {
            _this.partsFormArray.forEach(function (partGroup, index) {
                _this.initializeSelect2(partGroup, index);
            });
        });
        setTimeout(function () {
            _this.saveBtn.nativeElement.focus();
        }, 900);
    };
    FulfilPartsModal.prototype.save = function () {
        if (this.form.invalid) {
            return;
        }
        this.action = 'saving';
    };
    FulfilPartsModal.prototype.toggleDropdown = function () {
        if (!this._isProcessing) {
            var selectedOptions = this.fulfilFromStockRooms.filter(function (option) { return option.selected; });
            var unselectedOptions = this.fulfilFromStockRooms.filter(function (option) { return !option.selected; });
            this.fulfilFromStockRooms = selectedOptions.concat(unselectedOptions);
            this.filteredStockRooms = this.fulfilFromStockRooms.slice();
            this.searchLocation = '';
            this.massUpdateDropdownOpen = !this.massUpdateDropdownOpen;
            this.changeDetector.detectChanges();
        }
    };
    FulfilPartsModal.prototype.selectStockLocationFromMassUpdate = function () {
        var _this = this;
        this.changeDetector.detach(); // Detach change detection during mass update
        this._isProcessing = true;
        try {
            this.fulfilFromOthers.forEach(function (opt) { return (opt.selected = false); });
            var selectedSourceLabels_1 = this.fulfilFromStockRooms.filter(function (opt) { return opt.selected; }).map(function (opt) { return opt.id; });
            if (!selectedSourceLabels_1.length)
                return;
            var partsFormArray_1 = this.form.get('parts');
            var batchSize_1 = 20;
            var totalParts_1 = partsFormArray_1.length;
            var processed_1 = 0;
            var highlightIndices_1 = [];
            var clearHighlight_1 = function (idx) {
                if (_this.parts[idx]._quantityModifiedTimer) {
                    clearTimeout(_this.parts[idx]._quantityModifiedTimer);
                }
                _this.parts[idx].quantityModified = true;
                _this.parts[idx]._quantityModifiedTimer = setTimeout(function () {
                    _this.parts[idx].quantityModified = false;
                    _this.parts[idx]._quantityModifiedTimer = null;
                    _this.changeDetector.detectChanges();
                }, 2000);
            };
            var processBatch_1 = function () {
                var endIdx = Math.min(processed_1 + batchSize_1, totalParts_1);
                highlightIndices_1 = [];
                var _loop_1 = function (i) {
                    var partGroup = partsFormArray_1.at(i);
                    if (_this.parts[i].isFulfilled)
                        return "continue";
                    var prevAllocations = _this.parts[i].availableParts.map(function (loc) { return loc.allocation; });
                    _this.updatePartGroupForMassUpdate(partGroup, selectedSourceLabels_1);
                    var changed = _this.parts[i].availableParts.some(function (loc, idx) { return loc.allocation !== prevAllocations[idx]; });
                    if (changed && !_this.parts[i].hidden) {
                        clearHighlight_1(i);
                    }
                };
                for (var i = processed_1; i < endIdx; i++) {
                    _loop_1(i);
                }
                processed_1 = endIdx;
                _this.changeDetector.detectChanges();
                if (processed_1 < totalParts_1) {
                    setTimeout(processBatch_1, 0);
                }
                else {
                    _this._isProcessing = false;
                    _this.changeDetector.reattach();
                    _this.changeDetector.detectChanges();
                    _this.toggleDropdown(); // Only close dropdown after all batches processed
                    _this.logFulfillmentStatus('massUpdate');
                }
            };
            processBatch_1();
        }
        catch (error) {
            console.error('Error in mass update:', error);
            this._isProcessing = false;
            this.changeDetector.reattach();
            this.changeDetector.detectChanges();
        }
    };
    FulfilPartsModal.prototype.selectFulfilFromOthers = function (selectedOption) {
        var _this = this;
        if (this._isProcessing) {
            return;
        }
        this._isProcessing = true;
        try {
            var isUncheck_1 = selectedOption.selected;
            this.fulfilFromOthers.forEach(function (opt) { return (opt.selected = false); });
            if (!isUncheck_1) {
                selectedOption.selected = true;
            }
            var partsFormArray = this.form.get('parts');
            this.changeDetector.detach();
            partsFormArray.controls.forEach(function (partGroup, index) {
                if (_this.parts[index].isFulfilled) {
                    return;
                }
                _this.updatePartForFulfilFromOthers(partGroup, selectedOption, isUncheck_1);
            });
            this.changeDetector.reattach();
            this.changeDetector.detectChanges();
            this.toggleDropdown();
            this.formUpdateDebouncer.next();
        }
        finally {
            this._isProcessing = false;
            this.toggleDropdown();
        }
    };
    FulfilPartsModal.prototype.selectManualFulfilFromOthers = function (selectedOption, partGroup) {
        if (this._isProcessing) {
            return;
        }
        this._isProcessing = true;
        try {
            var remainingQty = this.calculateRemainingQuantity(partGroup);
            var partIndex = this.partsFormArray.indexOf(partGroup);
            // Centralized logic for orderToSupplier and General location
            this.handleOtherFulfillmentEffects(partGroup, selectedOption, remainingQty);
            // Then update the Select2 element from the form control's new value
            var currentOtherSelection = partGroup.get('selectFulfilFromOther').value;
            this.updateSelect2Element(partIndex, currentOtherSelection ? String(currentOtherSelection) : '', false);
            this.updatePartQuantityConstraints(partGroup);
            this.changeDetector.reattach();
            this.changeDetector.detectChanges();
            // this.toggleDropdown();
            this.formUpdateDebouncer.next();
        }
        finally {
            this._isProcessing = false;
        }
    };
    FulfilPartsModal.prototype.getSelectedLabel = function () {
        var selectedMulti = this.fulfilFromStockRooms
            .filter(function (opt) { return opt.selected; })
            .map(function (opt) { return opt.label; });
        return selectedMulti.length ? selectedMulti.join(', ') : '';
    };
    FulfilPartsModal.prototype.onDocumentClick = function (event) {
        if (!this.massUpdateContainer) {
            return;
        }
        var container = this.massUpdateContainer.nativeElement;
        if (!container.contains(event.target) && this.massUpdateDropdownOpen) {
            this.toggleDropdown();
        }
    };
    FulfilPartsModal.prototype.createPartGroup = function (part) {
        var _this = this;
        var remainingQty = part.totalQuantity; // Initial remaining quantity is the full part quantity
        var initialFulfilOptions = this.fulfilFromOthers.map(function (opt) { return (tslib_1.__assign({}, opt, { label: opt.label.split(' (')[0] + " (" + remainingQty + ")" })); });
        return this.formBuilder.group({
            jobPartId: [part.jobPartId],
            partId: [part.partId],
            name: [part.name],
            code: [part.code],
            orderToSupplier: [part.orderToSupplier || 0],
            totalQuantity: [part.totalQuantity],
            selectFulfilFromOther: [part.selectFulfilFromOther],
            selectFulfilFromOtherQty: [part.selectFulfilFromOtherQty],
            hidden: [part.hidden],
            isFulfilled: [part.isFulfilled],
            availableParts: this.formBuilder.array(part.availableParts.map(function (loc) { return _this.createLocationGroup(loc, part.partId); }))
        }, {
            validators: [this.validatePartTotalQty()]
        });
    };
    FulfilPartsModal.prototype.createLocationGroup = function (loc, partId) {
        var _this = this;
        var hasSufficientStock = loc.quantity > 0;
        var group = this.formBuilder.group({
            id: [loc.id],
            location: [loc.location],
            quantity: [loc.quantity],
            selected: [{
                    value: loc.selected,
                    disabled: !hasSufficientStock
                }],
            view: [loc.view],
            engineerName: [loc.engineerName],
            quantityInDue: [loc.quantityInDue],
            partId: [partId],
            allocation: [{
                    value: loc.allocation || null,
                    disabled: !loc.selected
                }, [
                    Validators.min(0),
                    Validators.pattern(/^\d*\.?\d{0,2}$/)
                ]]
        });
        // Handle selected checkbox changes
        group.get('selected').valueChanges.subscribe(function (checked) {
            var qtyControl = group.get('allocation');
            var partGroup = group.parent.parent;
            var quantity = group.get('quantity').value; // Get the quantity
            var isSufficient = quantity > 0;
            if (checked && isSufficient) {
                qtyControl.enable();
                // Don't reset the value when enabling
                if (qtyControl.value === null) {
                    qtyControl.setValue('');
                }
            }
            else {
                qtyControl.setValue(null, { emitEvent: false }); // Set to null when unchecked
                qtyControl.disable();
            }
            // Check if part is fully fulfilled after selection change
            _this.checkAndUpdateFulfilFromOtherState(partGroup);
        });
        // Handle quantity value changes
        group.get('allocation').valueChanges.subscribe(function (currentQtyInput) {
            if (!group.get('selected').value) {
                return;
            }
            var partGroup = group.parent.parent;
            if (!partGroup) {
                return;
            }
            var totalRequired = partGroup.get('totalQuantity').value;
            var stockControl = group.get('quantity');
            var availableStock = stockControl.value;
            var partsArray = _this.form.get('parts');
            var partIndex = partsArray.controls.indexOf(partGroup);
            var availableParts = partGroup.get('availableParts');
            var locationIndex = availableParts.controls.indexOf(group);
            var selectFulfilFromOtherControl = partGroup.get('selectFulfilFromOther');
            var isInputInvalid = isNaN(currentQtyInput) || currentQtyInput === null || currentQtyInput === '';
            if (isInputInvalid) {
                if (partIndex !== -1 && locationIndex !== -1) {
                    _this.parts[partIndex].availableParts[locationIndex].allocation = 0;
                }
            }
            else {
                var adjustedQty = parseFloat(currentQtyInput);
                var otherLocationsQty = availableParts.controls
                    .filter(function (control) { return control !== group && control.get('selected').value === true; })
                    .reduce(function (sum, control) {
                    var allocation = parseFloat(control.get('allocation').value);
                    return sum + (isNaN(allocation) ? 0 : allocation);
                }, 0);
                var remainingAllowed = Math.max(0, totalRequired - otherLocationsQty);
                var maxForThisInput = Math.min(availableStock, remainingAllowed);
                if (adjustedQty > maxForThisInput) {
                    adjustedQty = maxForThisInput;
                }
                if (adjustedQty < 0) {
                    adjustedQty = 0;
                }
                adjustedQty = parseFloat(adjustedQty.toFixed(2));
                if (group.get('allocation').value !== adjustedQty) {
                    group.get('allocation').setValue(adjustedQty, { emitEvent: false });
                }
                if (partIndex !== -1 && locationIndex !== -1) {
                    _this.parts[partIndex].availableParts[locationIndex].allocation = adjustedQty;
                }
            }
            // Check fulfillment status and update UI accordingly
            var totalFulfilled = availableParts.controls
                .filter(function (loc) { return loc.get('selected').value; })
                .reduce(function (sum, loc) {
                var allocation = parseFloat(loc.get('allocation').value);
                return sum + (isNaN(allocation) ? 0 : allocation);
            }, 0);
            var isFulfilled = totalFulfilled >= totalRequired;
            if (_this.parts[partIndex]) {
                _this.parts[partIndex].isFulfilled = isFulfilled;
            }
            var select2Element = $("#fulfil-from-other-" + partIndex);
            if (isFulfilled) {
                if (selectFulfilFromOtherControl.enabled) {
                    selectFulfilFromOtherControl.disable({ emitEvent: false });
                    if (select2Element.length) {
                        select2Element.prop('disabled', true);
                    }
                }
            }
            else {
                if (selectFulfilFromOtherControl.disabled) {
                    selectFulfilFromOtherControl.enable({ emitEvent: false });
                    if (select2Element.length) {
                        select2Element.prop('disabled', false);
                    }
                }
            }
            _this.changeDetector.detectChanges();
        });
        return group;
    };
    FulfilPartsModal.prototype.validatePartTotalQty = function () {
        return function (group) {
            var totalQuantity = group.get('totalQuantity').value;
            var stockLocs = group.get('availableParts');
            var selectedQtySum = stockLocs.controls
                .filter(function (loc) { return loc.get('selected').value; })
                .reduce(function (sum, loc) { return sum + (+loc.get('allocation').value || 0); }, 0);
            return selectedQtySum > totalQuantity ? { exceedsPartQty: true } : null;
        };
    };
    FulfilPartsModal.prototype.getLocations = function (i) {
        return this.partsFormArray[i].get('availableParts')['controls'];
    };
    FulfilPartsModal.prototype.updateLocation = function () {
        if (!this._select2StockLocs) {
            return;
        }
        var selectedIds = $(this._select2StockLocs.nativeElement).val();
        if (typeof selectedIds === 'string') {
            selectedIds = selectedIds.split(',').map(function (id) { return Number(id.trim()); });
        }
        // Ensure this.selectedEngineerStockLocations always holds the current user selection
        this.selectedEngineerStockLocations = Array.isArray(selectedIds) ? selectedIds : (selectedIds ? [selectedIds] : []);
        this.form.controls['checkEngineerStockLocations'].setValue(selectedIds && selectedIds.length > 0 ? selectedIds : null);
        // Update fulfilFromStockRooms based on the actual current selection
        if (this.selectedEngineerStockLocations && this.selectedEngineerStockLocations.length > 0) {
            var selectedLocations = this.engineerStocklocations.filter(function (location) {
                return selectedIds.map(function (id) { return id.toString(); }).includes(location.id.toString());
            });
            this.fulfilFromStockRooms = selectedLocations.map(function (location) { return ({
                id: location.id,
                label: location.text,
                selected: false
            }); });
        }
        else {
            this.fulfilFromStockRooms = [];
        }
        this.changeDetector.detectChanges();
    };
    FulfilPartsModal.prototype.getPartsAvailableStockLocations = function () {
        var _this = this;
        this.jobViewService.getPartsAvailableStockLocations(this.customerId, this.customerType, this.jobId, this.selectedPartsId).subscribe(function (data) {
            _this.engineerStocklocations = data['engineerStocklocations'];
            _this.selectedEngineerStockLocations = data['engineerStocklocationIds'];
            _this.isStockModule = data['isStockModule'];
            _this.form.get('checkEngineerStockLocations').setValue(_this.selectedEngineerStockLocations);
            _this.fulfilFromStockRooms = _this.engineerStocklocations.map(function (location) { return ({
                id: location.id,
                label: location.text,
                selected: false
            }); });
            _this.partsStockLocations = data['partsAvailableStocklocations'];
            var partsStockLocationsAvailable = data['partsAvailableStocklocations'];
            var partsFormated = Object.keys(_this.selectedRows).map(function (id) {
                var partData = _this.selectedRows[id];
                var partId = partData.partId;
                var locationData = partsStockLocationsAvailable.find(function (p) { return p.part_id === partId; });
                // Check if location data is empty or has no stock
                var isOutOfStock = !locationData || !locationData.locations || locationData.locations.length === 0 ||
                    locationData.locations.every(function (loc) { return !(loc.view === true && loc.location !== 'General' && loc.quantity > 0); });
                return {
                    jobPartId: id,
                    partId: partId,
                    name: partData.Part,
                    code: partData.MPN,
                    orderToSupplier: 0,
                    totalQuantity: parseFloat(partData.Quantity),
                    outOfStock: isOutOfStock,
                    fulfilFromOthers: _this.fulfilFromOthers,
                    selectFulfilFromOther: '',
                    selectFulfilFromOtherQty: 0,
                    availableParts: (locationData.locations || []).map(function (loc) { return ({
                        id: loc.id,
                        location: loc.location,
                        quantity: loc.quantity || 0,
                        quantityInDue: loc.quantityInDue || 0,
                        engineerName: loc.engineerName,
                        allocation: 0,
                        selected: false,
                        view: loc.view
                    }); }),
                    hidden: false,
                    isFulfilled: false
                };
            });
            _this.parts = partsFormated;
            var partsFormArray = _this.form.get('parts');
            _this.parts.forEach(function (part) {
                partsFormArray.push(_this.createPartGroup(part));
            });
            _this.isDataReady = true;
            _this.changeDetector.detectChanges();
        }, function (error) {
            console.error('error', error);
        });
    };
    FulfilPartsModal.prototype.initStockLocationSelect2 = function () {
        var _this = this;
        this.stockLocationsSelect2Config = {
            multiple: true,
            query: function (query) {
                if (query.term) {
                    _this.jobViewService.getAllStockLocations(query.term).subscribe(function (response) {
                        var newLocations = response && Array.isArray(response) ? response.filter(function (item) { return item && typeof item === 'object' && item.id !== undefined; }) : [];
                        var allCurrentAndNewLocations = _this.engineerStocklocations.concat(newLocations);
                        _this.engineerStocklocations = Array.from(new Map(allCurrentAndNewLocations.map(function (item) { return [item.id, item]; })).values());
                        var filteredResults = _this.engineerStocklocations.filter(function (loc) {
                            return loc.text.toLowerCase().includes(query.term.toLowerCase());
                        });
                        query.callback({ results: filteredResults });
                    });
                }
                else {
                    query.callback({ results: _this.engineerStocklocations });
                }
            },
            initSelection: function (element, callback) {
                var data = [];
                var selectedIds = _this.selectedEngineerStockLocations;
                var allLocations = _this.engineerStocklocations;
                var _loop_2 = function (id) {
                    var location_1 = allLocations.find(function (loc) { return loc.id.toString() === id.toString(); });
                    if (location_1) {
                        data.push(location_1);
                    }
                };
                for (var _i = 0, selectedIds_1 = selectedIds; _i < selectedIds_1.length; _i++) {
                    var id = selectedIds_1[_i];
                    _loop_2(id);
                }
                callback(data);
            }
        };
    };
    FulfilPartsModal.prototype.updateLocationViewStatus = function () {
        var _this = this;
        // Ensure selectedLocationIds is an array, even if null/undefined initially from select2
        var selectedLocationIds = this.form.get('checkEngineerStockLocations').value || [];
        var partsFormArray = this.form.get('parts');
        partsFormArray.controls.forEach(function (partGroup, partIndex) {
            var stockLocationsFormArray = partGroup.get('availableParts');
            var hasVisibleAndStockedLocations = false;
            stockLocationsFormArray.controls.forEach(function (locGroup, locationIndex) {
                var locationIdInForm = locGroup.get('id').value;
                // Crucially, ensure both sides of includes() are consistent types (strings)
                // The select2 value for multi-select is usually an array of strings.
                var isLocationSelectedInDropdown = selectedLocationIds
                    .map(function (id) { return id.toString(); })
                    .includes(locationIdInForm.toString());
                // Set the 'view' control value
                locGroup.get('view').setValue(isLocationSelectedInDropdown);
                // If the location is NOT selected in the main dropdown,
                // it should be unselected and its quantity reset in the part's form group.
                if (!isLocationSelectedInDropdown) {
                    if (locGroup.get('selected').value === true) { // Only change if it was previously selected
                        locGroup.get('selected').setValue(false, { emitEvent: false });
                        locGroup.get('allocation').setValue(0, { emitEvent: false });
                        locGroup.get('allocation').disable({ emitEvent: false });
                        // Update the component's internal data model for consistency
                        if (_this.parts[partIndex] && _this.parts[partIndex].availableParts[locationIndex]) {
                            _this.parts[partIndex].availableParts[locationIndex].selected = false;
                            _this.parts[partIndex].availableParts[locationIndex].allocation = 0;
                        }
                    }
                }
                else {
                    //If it IS selected in the main dropdown, ensure its allocation control is ENABLED
                    // if its 'selected' checkbox within the part is true. This handles re-enabling.
                    if (locGroup.get('selected').value === true && locGroup.get('allocation').disabled) {
                        locGroup.get('allocation').enable({ emitEvent: false });
                    }
                }
                // Re-evaluate hasVisibleAndStockedLocations for this part
                // Only consider locations that are viewable, not 'General', and have stock.
                //Check locGroup.get('view').value directly AFTER setValue
                if (locGroup.get('view').value === true && locGroup.get('location').value !== 'General' && locGroup.get('quantity').value > 0) {
                    hasVisibleAndStockedLocations = true;
                }
            });
            // Update the part's outOfStock status based on whether any visible, stocked locations exist
            // This is the source of truth for the 'out of stock' message.
            if (_this.parts[partIndex]) {
                _this.parts[partIndex].outOfStock = !hasVisibleAndStockedLocations;
            }
            _this.updatePartState(partGroup, partIndex);
        });
        this.changeDetector.detectChanges();
        this.formUpdateDebouncer.next();
    };
    FulfilPartsModal.prototype.updatePartQuantityConstraints = function (partGroup) {
        if (!partGroup) {
            return;
        }
        var partIndex = this.partsFormArray.findIndex(function (p) { return p === partGroup; });
        if (partIndex === -1) {
            return;
        }
        // Update fulfillment status
        this.updatePartState(partGroup, partIndex);
        // Trigger debounced update instead of direct call
        this.formUpdateDebouncer.next();
        // Update form validation
        partGroup.updateValueAndValidity({ emitEvent: true });
        this.changeDetector.detectChanges();
    };
    FulfilPartsModal.prototype.getRemainingQty = function (partGroup) {
        if (!partGroup) {
            return 0;
        }
        var totalQty = partGroup.get('totalQuantity').value;
        var availableParts = partGroup.get('availableParts');
        var fulfilledQty = availableParts.controls
            .filter(function (loc) { return loc.get('selected').value; })
            .reduce(function (sum, loc) { return sum + (+loc.get('allocation').value || 0); }, 0);
        return Math.max(0, totalQty - fulfilledQty);
    };
    FulfilPartsModal.prototype.ngOnDestroy = function () {
        this.changeDetector.detach();
        // Cleanup select2 instances for main dropdown on destroy
        if (this._select2StockLocs && $(this._select2StockLocs.nativeElement).data('select2')) {
            $(this._select2StockLocs.nativeElement).select2('destroy');
        }
        // Cleanup select2 instances
        this.partsFormArray.forEach(function (_, index) {
            $("#fulfil-from-other-" + index).select2('destroy');
        });
        this.destroyed$.next();
        this.destroyed$.complete();
        this.formUpdateDebouncer.complete();
    };
    FulfilPartsModal.prototype.calculateRemainingQuantity = function (partGroup) {
        var totalQty = partGroup.get('totalQuantity').value;
        var availableParts = partGroup.get('availableParts');
        var fulfilledQty = availableParts.controls
            .filter(function (loc) { return loc.get('selected').value; })
            .reduce(function (sum, loc) { return sum + (+loc.get('allocation').value || 0); }, 0);
        return Math.max(0, totalQty - fulfilledQty);
    };
    FulfilPartsModal.prototype.updateSelect2Element = function (index, value, disabled) {
        if (value === void 0) { value = null; }
        if (disabled === void 0) { disabled = false; }
        var select2Element = $("#fulfil-from-other-" + index);
        select2Element.prop('disabled', disabled);
        if (value !== null) {
            select2Element.val(value).trigger('change');
        }
    };
    FulfilPartsModal.prototype.updateLocationControls = function (locGroup, selected, allocation) {
        if (allocation === void 0) { allocation = ''; }
        var qtyControl = locGroup.get('allocation');
        var selectedControl = locGroup.get('selected');
        selectedControl.setValue(selected, { emitEvent: false });
        qtyControl[selected ? 'enable' : 'disable']({ emitEvent: false });
        qtyControl.setValue(allocation, { emitEvent: false });
        // locGroup.get('view').setValue(true);
    };
    FulfilPartsModal.prototype.updatePartGroupForMassUpdate = function (partGroup, selectedSourceLabels) {
        var partIndex = this.partsFormArray.indexOf(partGroup);
        var remainingQtyToDistribute = partGroup.get('totalQuantity').value;
        var availableParts = partGroup.get('availableParts');
        // Store current quantities before reset
        var currentQtys = new Map();
        availableParts.controls.forEach(function (loc) {
            if (loc.get('selected').value && loc.get('allocation').value !== null) {
                currentQtys.set(loc.get('id').value, loc.get('allocation').value);
            }
        });
        // Reset form control values
        this.resetPartGroupControls(partGroup);
        this.updateLocationsForMassUpdate(availableParts, selectedSourceLabels, remainingQtyToDistribute, currentQtys);
        // Handle remaining quantity and select2 updates
        this.handleRemainingQuantity(partGroup, partIndex);
    };
    FulfilPartsModal.prototype.resetPartGroupControls = function (partGroup) {
        partGroup.patchValue({
            selectFulfilFromOther: '',
            selectFulfilFromOtherQty: 0,
            orderToSupplier: 0
        }, { emitEvent: false });
    };
    FulfilPartsModal.prototype.updateLocationsForMassUpdate = function (locationsArray, selectedIds, remainingQty, currentQtys) {
        var _this = this;
        var partGroup = locationsArray.parent;
        var partIndex = this.partsFormArray.indexOf(partGroup);
        var partRequiredQty = partGroup.get('totalQuantity').value;
        var select2Element = $("#fulfil-from-other-" + partIndex);
        // Combine resets into a single loop for better performance
        var controls = locationsArray.controls;
        var partAvailableParts = partIndex !== -1 ? this.parts[partIndex].availableParts : null;
        for (var i = 0; i < controls.length; i++) {
            var locGroup = controls[i];
            // Reset form controls
            this.updateLocationControls(locGroup, false, '');
            // Reset data model if available
            if (partAvailableParts && partAvailableParts[i]) {
                partAvailableParts[i].allocation = 0;
                partAvailableParts[i].selected = false;
            }
        }
        // Distribute quantities among newly selected or previously partially/fully fulfilled locations
        var quantityToDistribute = partRequiredQty;
        // First, prioritize re-applying quantities to locations that were previously fulfilling the part
        locationsArray.controls.forEach(function (locGroup, locationIndex) {
            var id = locGroup.get('id').value;
            var isNewlySelected = selectedIds.includes(id);
            var availableStockQty = locGroup.get('quantity').value;
            var hasStock = availableStockQty !== null && availableStockQty > 0;
            var isAlreadyHandled = locGroup.get('selected').value && locGroup.get('allocation').value > 0;
            if (isNewlySelected && hasStock && !isAlreadyHandled && quantityToDistribute > 0) {
                var availableStock = locGroup.get('quantity').value;
                var qtyToTake = Math.min(quantityToDistribute, availableStock);
                _this.updateLocationControls(locGroup, true, qtyToTake);
                quantityToDistribute -= qtyToTake;
                if (partIndex !== -1 && _this.parts[partIndex].availableParts[locationIndex]) {
                    _this.parts[partIndex].availableParts[locationIndex].allocation = qtyToTake;
                    _this.parts[partIndex].availableParts[locationIndex].selected = true;
                }
            }
        });
        // Then, distribute remaining quantity among newly selected locations (if any remaining)
        locationsArray.controls.forEach(function (locGroup, locationIndex) {
            var id = locGroup.get('id').value;
            var isNewlySelected = selectedIds.includes(id);
            var isAlreadyHandled = locGroup.get('selected').value && locGroup.get('allocation').value > 0;
            var availableStockQty = locGroup.get('quantity').value;
            var hasStock = availableStockQty !== null && availableStockQty > 0;
            if (isNewlySelected && hasStock && !isAlreadyHandled && quantityToDistribute > 0) {
                var availableStock = locGroup.get('quantity').value;
                var qtyToTake = Math.min(quantityToDistribute, availableStock);
                _this.updateLocationControls(locGroup, true, qtyToTake);
                quantityToDistribute -= qtyToTake;
                // Update parts array data model
                if (partIndex !== -1 && _this.parts[partIndex].availableParts[locationIndex]) {
                    _this.parts[partIndex].availableParts[locationIndex].allocation = qtyToTake;
                    _this.parts[partIndex].availableParts[locationIndex].selected = true;
                }
            }
        });
        // If there's still a remaining quantity after distributing from stock, update the "fulfil from other" section
        var selectedOptionFromMassUpdate = this.fulfilFromOthers.find(function (opt) { return opt.selected; });
        var currentOtherSelectionInForm = partGroup.get('selectFulfilFromOther').value;
        if (remainingQty > 0) {
            if (selectedOptionFromMassUpdate) {
                // If a mass update option for 'other' is chosen, apply it
                partGroup.patchValue({
                    selectFulfilFromOther: selectedOptionFromMassUpdate.id,
                    selectFulfilFromOtherQty: remainingQty
                }, { emitEvent: false });
                this.updateSelect2Element(partIndex, String(selectedOptionFromMassUpdate.id));
                this.handleOtherFulfillmentEffects(partGroup, selectedOptionFromMassUpdate.id, remainingQty);
            }
            else if (currentOtherSelectionInForm) {
                // If there's an existing 'other' selection and no new mass update for 'other',
                // just update its quantity and re-apply its effects with the new quantity.
                partGroup.patchValue({
                    selectFulfilFromOtherQty: remainingQty // Only update quantity
                }, { emitEvent: false });
                this.updateSelect2Element(partIndex, String(currentOtherSelectionInForm)); // Keep visual
                this.handleOtherFulfillmentEffects(partGroup, currentOtherSelectionInForm, remainingQty);
            }
            else {
                // No mass update 'other' selected, no previous 'other' selection, and still remaining qty
                // Keep the fields clear, but enable the select2.
                partGroup.patchValue({
                    selectFulfilFromOther: '',
                    selectFulfilFromOtherQty: 0
                }, { emitEvent: false });
                this.updateSelect2Element(partIndex, '');
                this.handleOtherFulfillmentEffects(partGroup, null, 0); // Ensure effects are cleared
            }
        }
        else {
            select2Element.prop('disabled', true); // Disable the control
        }
        // Re-enable select2 if no stock locations are selected and not fully fulfilled
        // This condition should now correctly enable the select2 if remainingQty > 0.
        if (remainingQty > 0) { // Removed hasSelectedStockLocations check, remainingQty is sufficient
            this.updateSelect2Element(partIndex, null, false); // Enable select2
        }
        partGroup.updateValueAndValidity();
    };
    FulfilPartsModal.prototype.handleRemainingQuantity = function (partGroup, partIndex) {
        var availableParts = partGroup.get('availableParts');
        // Calculate fulfilled and remaining quantities
        var fulfilledQty = availableParts.controls
            .filter(function (loc) { return loc.get('selected').value; })
            .reduce(function (sum, loc) { return sum + (+loc.get('allocation').value || 0); }, 0);
        var remainingQty = Math.max(0, partGroup.get('totalQuantity').value - fulfilledQty);
        // Get select2 element
        var select2Element = $("#fulfil-from-other-" + partIndex);
        var currentOtherSelectionInForm = partGroup.get('selectFulfilFromOther').value;
        if (remainingQty > 0) {
            // Enable select2 if there's remaining quantity
            select2Element.prop('disabled', false);
            // Apply mass update option if selected
            var selectedOption = this.fulfilFromOthers.find(function (opt) { return opt.selected; });
            if (selectedOption) {
                partGroup.patchValue({
                    selectFulfilFromOther: selectedOption.id,
                    selectFulfilFromOtherQty: remainingQty
                }, { emitEvent: false });
                // select2Element.val(selectedOption.id.toString()).trigger('change');
                this.updateSelect2Element(partIndex, String(selectedOption.id));
                // Trigger effects for "other" fulfillment
                this.handleOtherFulfillmentEffects(partGroup, selectedOption.id, remainingQty);
            }
            else if (currentOtherSelectionInForm) {
                // If there's an existing 'other' selection and no new mass update for 'other',
                // just update its quantity and re-apply its effects with the new quantity.
                partGroup.patchValue({
                    selectFulfilFromOtherQty: remainingQty
                }, { emitEvent: false });
                this.updateSelect2Element(partIndex, String(currentOtherSelectionInForm)); // Keep visual
                this.handleOtherFulfillmentEffects(partGroup, currentOtherSelectionInForm, remainingQty);
            }
            else {
                partGroup.patchValue({
                    selectFulfilFromOther: '',
                    selectFulfilFromOtherQty: 0
                }, { emitEvent: false });
                this.updateSelect2Element(partIndex, '');
                // If no mass update option, ensure other effects are cleared if they were applied
                this.handleOtherFulfillmentEffects(partGroup, null, 0);
            }
        }
        else {
            select2Element.prop('disabled', true);
        }
        // Update form validation
        partGroup.updateValueAndValidity();
        this.updatePartQuantityConstraints(partGroup);
    };
    FulfilPartsModal.prototype.updatePartForFulfilFromOthers = function (partGroup, selectedOption, isUncheck) {
        var remainingQty = this.calculateRemainingQuantity(partGroup);
        var partIndex = this.partsFormArray.indexOf(partGroup);
        if (!isUncheck && remainingQty > 0) {
            partGroup.patchValue({
                selectFulfilFromOther: selectedOption.id,
                selectFulfilFromOtherQty: remainingQty
            }, { emitEvent: false });
            this.updateSelect2Element(partIndex, selectedOption.id.toString());
            // Trigger effects for "other" fulfillment
            this.handleOtherFulfillmentEffects(partGroup, selectedOption.id, remainingQty);
        }
        else {
            partGroup.patchValue({
                selectFulfilFromOther: '',
                selectFulfilFromOtherQty: 0
            }, { emitEvent: false });
            this.updateSelect2Element(partIndex, '');
            // Clear effects for "other" fulfillment
            this.handleOtherFulfillmentEffects(partGroup, null, 0);
        }
        this.updatePartQuantityConstraints(partGroup);
    };
    FulfilPartsModal.prototype.logFulfillmentStatus = function (action) {
        var summary = this.calculateFulfillmentSummary();
        console.log("[" + action + "] Fulfillment Status:", summary);
        console.log('form parts', this.form.get('parts').value);
        console.log('parts', this.parts);
        return summary;
    };
    FulfilPartsModal.prototype.calculateFulfillmentSummary = function () {
        var _this = this;
        var summary = {
            stockLocationTotals: [],
            otherSourceTotals: {
                'job.purchase.order': 0,
                'job.leave.remaining': 0,
                'job.general': 0
            },
            fulfilledPartsCount: 0,
            notFulfilledPartsCount: 0,
            totalPartsCount: 0
        };
        var partsFormArray = this.form.get('parts');
        partsFormArray.controls.forEach(function (partGroup, partIndex) {
            summary.totalPartsCount++;
            var currentPartInPartsArray = _this.parts[partIndex];
            // Calculate stock location quantities
            var availableParts = partGroup.get('availableParts');
            availableParts.controls.forEach(function (locGroup, locationIndex) {
                //
                if (locGroup.get('view').value && !_this.parts[partIndex].availableParts[locationIndex].view) {
                    currentPartInPartsArray.availableParts[locationIndex].view = locGroup.get('view').value;
                }
                if (locGroup.get('selected').value) {
                    var id_1 = locGroup.get('id').value;
                    var location_2 = locGroup.get('location').value;
                    var allocation = +locGroup.get('allocation').value || 0;
                    currentPartInPartsArray.availableParts[locationIndex].selected = locGroup.get('selected').value;
                    if (allocation > 0) {
                        var existingLocation = summary.stockLocationTotals.find(function (loc) { return loc.id === id_1; });
                        if (existingLocation) {
                            existingLocation.totalQty += allocation;
                        }
                        else {
                            summary.stockLocationTotals.push({
                                id: id_1,
                                location: location_2,
                                totalQty: allocation
                            });
                        }
                    }
                }
            });
            // Calculate other source quantities using the mapping
            var fulfilFromOtherValue = partGroup.get('selectFulfilFromOther').value;
            var selectFulfilFromOtherQty = partGroup.get('selectFulfilFromOtherQty').value; // Get actual quantity from form
            if (fulfilFromOtherValue && selectFulfilFromOtherQty > 0) {
                var sourceKey = _this.fulfilFromOtherMapping[fulfilFromOtherValue];
                if (sourceKey && fulfilFromOtherValue !== 3 && fulfilFromOtherValue !== 3) {
                    summary.otherSourceTotals[sourceKey] += selectFulfilFromOtherQty;
                }
            }
            // Update fulfilled status based on total quantities
            var totalQty = partGroup.get('totalQuantity').value;
            var stockLocationQty = availableParts.controls
                .filter(function (loc) { return loc.get('selected').value; })
                .reduce(function (sum, loc) { return sum + (+loc.get('allocation').value || 0); }, 0);
            var currentOtherFulfilQty = partGroup.get('selectFulfilFromOtherQty').value || 0;
            var isFulfilled = (stockLocationQty + currentOtherFulfilQty) >= totalQty;
            // Ensure isFulfilled in the internal parts array is updated
            if (currentPartInPartsArray) {
                currentPartInPartsArray.isFulfilled = isFulfilled;
            }
            if (isFulfilled) {
                summary.fulfilledPartsCount++;
            }
            else {
                summary.notFulfilledPartsCount++;
            }
        });
        this.completionSummary = summary;
        this.isOrderFromSupplier = this.parts.some(function (part) { return part.orderToSupplier && part.orderToSupplier > 0; });
        this.changeDetector.detectChanges();
        return summary;
    };
    FulfilPartsModal.prototype.onFulfilFromOtherChange = function (selectedValue, partGroup, index) {
        var totalRequired = partGroup.get('totalQuantity').value;
        var stockLocationQty = this.calculateStockLocationQty(partGroup);
        var remainingQty = Math.max(0, totalRequired - stockLocationQty);
        var select2Element = $("#fulfil-from-other-" + index);
        if (select2Element.length) {
            select2Element.val(selectedValue).trigger('change');
        }
        this.handleOtherFulfillmentEffects(partGroup, selectedValue, selectedValue ? remainingQty : 0);
        var status = this.updatePartState(partGroup, index);
        this.changeDetector.detectChanges();
        this.formUpdateDebouncer.next();
        this.logFulfillmentStatus("Fulfillment status updated: " + status.totalFulfilled + "/" + partGroup.get('totalQuantity').value);
    };
    FulfilPartsModal.prototype.calculateStockLocationQty = function (partGroup) {
        var availableParts = partGroup.get('availableParts');
        return availableParts.controls
            .filter(function (loc) { return loc.get('selected').value; })
            .reduce(function (sum, loc) { return sum + (+loc.get('allocation').value || 0); }, 0);
    };
    FulfilPartsModal.prototype.updateAllPartStatuses = function () {
        var _this = this;
        this.partsFormArray.forEach(function (partGroup, index) {
            var totalRequired = partGroup.get('totalQuantity').value;
            var stockLocationQty = _this.calculateStockLocationQty(partGroup);
            var fulfilFromOther = partGroup.get('selectFulfilFromOther').value;
            var remainingQty = Math.max(0, totalRequired - stockLocationQty);
            _this.parts[index].isFulfilled = fulfilFromOther ?
                (stockLocationQty + remainingQty) >= totalRequired :
                stockLocationQty >= totalRequired;
            _this.parts[index].hidden = _this.parts[index].isFulfilled;
            _this.changeDetector.detectChanges();
        });
        this.changeDetector.detectChanges();
        this.updateSummary();
    };
    FulfilPartsModal.prototype.updateSummary = function () {
        var totalParts = this.parts.length;
        var fulfilledParts = this.parts.filter(function (p) { return p.isFulfilled; }).length;
        // Update your summary display logic here
        this.logFulfillmentStatus("Parts fulfilled: " + fulfilledParts + "/" + totalParts);
    };
    FulfilPartsModal.prototype.getOptionTemplate = function (index) {
        var _this = this;
        return function (data) {
            if (!data.id) {
                return data.text;
            }
            var option = _this.fulfilFromOthers.find(function (opt) { return opt.id === +data.id; });
            if (option) {
                var remainingQty = _this.getRemainingQty(_this.partsFormArray[index]);
                return option.label + " (" + remainingQty + ")";
            }
            return data.text;
        };
    };
    FulfilPartsModal.prototype.calculateFulfillmentStatus = function (partGroup) {
        var totalRequired = partGroup.get('totalQuantity').value;
        var stockLocationQty = this.calculateStockLocationQty(partGroup);
        var fulfilFromOtherValue = partGroup.get('selectFulfilFromOther').value;
        var remainingQty = Math.max(0, totalRequired - stockLocationQty);
        var fromOtherQty = fulfilFromOtherValue ? remainingQty : 0;
        var totalFulfilled = stockLocationQty + fromOtherQty;
        return {
            isFulfilled: totalFulfilled >= totalRequired,
            totalFulfilled: totalFulfilled,
            fromStock: stockLocationQty,
            fromOther: fromOtherQty
        };
    };
    FulfilPartsModal.prototype.updatePartState = function (partGroup, index) {
        var _this = this;
        var status = this.calculateFulfillmentStatus(partGroup);
        var select2Element = $("#fulfil-from-other-" + index);
        // Update part status
        this.parts[index].isFulfilled = status.isFulfilled;
        // Update UI visibility
        setTimeout(function () {
            _this.parts[index].hidden = status.isFulfilled;
        });
        // Update select2 state
        if (status.fromStock >= partGroup.get('totalQuantity').value) {
            select2Element.prop('disabled', true);
        }
        else {
            select2Element.prop('disabled', false);
        }
        this.changeDetector.detectChanges();
        return status;
    };
    FulfilPartsModal.prototype.initializeSelect2 = function (partGroup, index) {
        var _this = this;
        var select2Element = $("#fulfil-from-other-" + index);
        select2Element.select2({
            width: '100%',
            minimumResultsForSearch: Infinity,
            placeholder: '-- Select fulfil option --',
            allowClear: true,
            templateResult: this.getOptionTemplate(index),
            templateSelection: this.getOptionTemplate(index)
        }).on('select2:select select2:clear', function (e) {
            var selectedValue = e.type === 'select2:clear' ? '' : e.params.data.id;
            _this.onFulfilFromOtherChange(selectedValue, partGroup, index);
        });
        // Set initial value for select2 from the form control.
        // This is crucial for when the modal opens or tab switches.
        var currentSelectedOther = partGroup.get('selectFulfilFromOther').value;
        this.updateSelect2Element(index, currentSelectedOther ? String(currentSelectedOther) : '', false);
        // Initial state update
        this.updatePartState(partGroup, index);
    };
    FulfilPartsModal.prototype.checkAndUpdateFulfilFromOtherState = function (partGroup) {
        if (!partGroup)
            return;
        var totalRequired = partGroup.get('totalQuantity').value;
        var availableParts = partGroup.get('availableParts');
        var partsArray = this.form.get('parts');
        var partIndex = partsArray.controls.indexOf(partGroup);
        // Calculate total fulfilled from stock locations
        var totalFulfilled = availableParts.controls
            .filter(function (control) { return control.get('selected').value; })
            .reduce(function (sum, control) {
            var allocation = control.get('allocation').value;
            return sum + ((!isNaN(allocation) && allocation !== null) ? parseFloat(allocation) : 0);
        }, 0);
        // Get the select2 element
        var select2Element = $("#fulfil-from-other-" + partIndex);
        // Disable/enable based on fulfillment status
        if (totalFulfilled >= totalRequired) {
            select2Element.prop('disabled', true);
        }
        else {
            select2Element.prop('disabled', false);
        }
    };
    FulfilPartsModal.prototype.resetPartFulfillment = function (index, partItem) {
        if (index < 0 || index >= this.partsFormArray.length) {
            console.warn("Attempted to reset part at invalid index: " + index);
            return;
        }
        var partGroup = this.partsFormArray[index];
        var availableParts = partGroup.get('availableParts');
        // 1. Reset all stock location selections and quantities for this part
        availableParts.controls.forEach(function (locGroup, locationIndex) {
            locGroup.patchValue({
                selected: false,
                allocation: ''
            }, { emitEvent: false });
            locGroup.get('allocation').disable({ emitEvent: false });
            partItem.availableParts[locationIndex].selected = false;
            partItem.availableParts[locationIndex].allocation = '';
        });
        // Get a reference to the selectFulfilFromOther form control
        var fulfilFromOtherControl = partGroup.get('selectFulfilFromOther');
        // Enable the form control and reset its value
        if (fulfilFromOtherControl.disabled) {
            fulfilFromOtherControl.enable({ emitEvent: false });
        }
        fulfilFromOtherControl.setValue('', { emitEvent: false });
        // Update its isFulfilled and hidden status to 'not fulfilled'
        // This will also re-enable the Select2 dropdown via updatePartState
        this.parts[index].isFulfilled = false;
        this.parts[index].hidden = false;
        // Re-enable its associated Select2 dropdown and clear its value
        this.updateSelect2Element(index, '', false); // Clear value and enable
        this.handleOtherFulfillmentEffects(partGroup, null, 0);
        // Recalculate and update the state of this specific part
        this.updatePartState(partGroup, index);
        // Update validity of the part group and trigger debounced form update
        partGroup.updateValueAndValidity({ emitEvent: true });
        this.formUpdateDebouncer.next();
        this.changeDetector.detectChanges();
        this.logFulfillmentStatus("Part at index " + index + " reset.");
    };
    FulfilPartsModal.prototype.selectTab = function (tab) {
        var _this = this;
        this.activeTab = tab;
        this.changeDetector.detectChanges();
        // When switching back to 'requires', ensure Select2 is correctly initialized and its value set
        if (this.activeTab === 'requires') {
            // Use setTimeout to allow DOM rendering to complete, then re-initialize/set Select2
            setTimeout(function () {
                if (!$(_this._select2StockLocs.nativeElement).data('select2')) {
                    _this.initAndAttachMainSelect2();
                }
            }, 0);
        }
    };
    FulfilPartsModal.prototype.initAndAttachMainSelect2 = function () {
        var _this = this;
        if (this._select2StockLocs && this._select2StockLocs.nativeElement) {
            // Destroy any existing Select2 instance to prevent re-initialization issues
            if ($(this._select2StockLocs.nativeElement).data('select2')) {
                $(this._select2StockLocs.nativeElement).select2('destroy');
            }
            // Initialize Select2 with its config
            $(this._select2StockLocs.nativeElement).select2(this.stockLocationsSelect2Config); // Use the existing config
            // Set the value immediately after initialization
            $(this._select2StockLocs.nativeElement).val(this.selectedEngineerStockLocations).trigger('change');
            // Attach the change listener
            $(this._select2StockLocs.nativeElement).on('change', function () {
                _this.updateLocation(); // This updates this.selectedEngineerStockLocations and the form control
                _this.updateLocationViewStatus(); //
            });
        }
    };
    FulfilPartsModal.prototype.handleOtherFulfillmentEffects = function (partGroup, selectedFulfilOptionId, quantity) {
        var partIndex = this.partsFormArray.indexOf(partGroup);
        if (partIndex === -1) {
            return;
        }
        var currentPartInPartsArray = this.parts[partIndex]; // Reference to the part in this.parts array
        var availablePartsFormArray = partGroup.get('availableParts');
        var numericSelectedFulfilOptionId = typeof selectedFulfilOptionId === 'string' ? parseFloat(selectedFulfilOptionId) : selectedFulfilOptionId;
        partGroup.get('selectFulfilFromOther').setValue(selectedFulfilOptionId || '', { emitEvent: false });
        partGroup.get('selectFulfilFromOtherQty').setValue(quantity, { emitEvent: false });
        currentPartInPartsArray.selectFulfilFromOther = selectedFulfilOptionId;
        currentPartInPartsArray.selectFulfilFromOtherQty = quantity;
        // Reset orderToSupplier for this part
        currentPartInPartsArray.orderToSupplier = 0;
        partGroup.get('orderToSupplier').setValue(0, { emitEvent: false });
        // Reset General location allocation for this part (both form and internal model)
        var generalLocationGroup = availablePartsFormArray.controls.find(function (loc) { return loc.get('location').value === 'General'; });
        if (generalLocationGroup) {
            generalLocationGroup.get('allocation').setValue(0, { emitEvent: false }); // Reset quantity in form
            generalLocationGroup.get('selected').setValue(false, { emitEvent: false }); // Unselect in form
            generalLocationGroup.get('allocation').disable({ emitEvent: false }); // Disable input in form
            // Update internal data model for 'General' location
            var generalLocationInPartsArray = currentPartInPartsArray.availableParts.find(function (loc) { return loc.location === 'General'; });
            if (generalLocationInPartsArray) {
                generalLocationInPartsArray.allocation = 0;
                generalLocationInPartsArray.selected = false;
            }
        }
        // Apply new effects based on selected option
        if (numericSelectedFulfilOptionId === 1) { // 'Order remaining from supplier'
            currentPartInPartsArray.orderToSupplier = quantity;
            partGroup.get('orderToSupplier').setValue(quantity, { emitEvent: false });
        }
        else if (numericSelectedFulfilOptionId === 3) { // 'Fulfil from general'
            if (generalLocationGroup) {
                generalLocationGroup.get('allocation').setValue(quantity, { emitEvent: false });
                generalLocationGroup.get('selected').setValue(true, { emitEvent: false });
                generalLocationGroup.get('allocation').enable({ emitEvent: false });
                // Update internal data model for 'General' location
                var generalLocationInPartsArray = currentPartInPartsArray.availableParts.find(function (loc) { return loc.location === 'General'; });
                if (generalLocationInPartsArray) {
                    generalLocationInPartsArray.allocation = quantity;
                    generalLocationInPartsArray.selected = true;
                }
            }
        }
        this.changeDetector.detectChanges();
    };
    FulfilPartsModal.prototype.onCloseModal = function () {
        this.bsModalRef.hide();
        this.onClose.next('close');
    };
    FulfilPartsModal.prototype.filterStockRooms = function (filterText) {
        if (!filterText) {
            this.filteredStockRooms = this.fulfilFromStockRooms.slice();
        }
        else {
            this.filteredStockRooms = this.fulfilFromStockRooms.filter(function (option) {
                return option.label.toLowerCase().includes(filterText.toLowerCase());
            });
        }
    };
    FulfilPartsModal.prototype.partTrackBy = function (index, part) {
        return part.jobPartId;
    };
    FulfilPartsModal.prototype.locationTrackBy = function (index, location) {
        return location.get('id').value;
    };
    return FulfilPartsModal;
}());
export { FulfilPartsModal };
